const catalog = [
  {
    id: 'A30JEX',
    desc: '30’ EX Boom Lift – No Options',
    manu: 'Man Lift USA',
    price: '$288,225',
  },
  {
    id: 'A45JEX',
    desc: "45' EX Boom Lift - Fall Arrest Platform / Soft Touch System",
    manu: 'Man Lift USA',
    price: '$366,608',
  },
  {
    id: 'A60JEX',
    desc: "60' EX Boom Lift - Fall Arrest Platform / Soft Touch System",
    manu: 'Man Lift USA',
    price: '$436,500',
  },
  {
    id: '2032EX',
    desc: '20\' 32" Wide EX Scissor Lift - No Options',
    manu: 'Man Lift USA',
    price: '$129,568',
  },
  {
    id: '1932EX',
    desc: '19\' 32" Wide EX Scissor Lift - No Options',
    manu: 'Man Lift USA',
    price: '$114,450',
  },
  {
    id: '2632EX',
    desc: '26\' 32" Wide EX Scissor Lift - No Options',
    manu: 'Man Lift USA',
    price: '$134,568',
  },
  {
    id: '3268EX',
    desc: '32\' 68" Wide (RT) EX Scissor Lift - No Options',
    manu: 'Man Lift USA',
    price: '$271,397',
  },
];
const tableBody = document.querySelector('.table__catalog tbody');

catalog.forEach(item => {
  const row = document.createElement('tr');
  // Create cells for ID, Description, and Price
  const idCell = document.createElement('td');
  idCell.textContent = item.id;

  const descCell = document.createElement('td');
  descCell.textContent = item.desc;

  const manuCell = document.createElement('td');
  manuCell.textContent = item.manu;

  const priceCell = document.createElement('td');
  priceCell.textContent = item.price;

  // Append the cells to the row
  row.appendChild(idCell);
  row.appendChild(descCell);
  row.appendChild(manuCell);
  row.appendChild(priceCell);

  // Append the row to the table body
  tableBody.appendChild(row);
});
